var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "box-card" }, [
    _c(
      "div",
      {
        staticClass: "clearfix",
        attrs: { slot: "header", id: "device-general" },
        slot: "header",
      },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.$t("device.status_reports"))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "ring-card__header-buttons" },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.getStatusReports.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c("h4", [_vm._v("CHARTS")]),
        _vm._v(" "),
        _c("StatusReportCharts", { attrs: { reports: _vm.reportData } }),
        _vm._v(" "),
        _c("h4", [_vm._v("DETAILS")]),
        _vm._v(" "),
        !_vm.error.value
          ? _c(
              "el-table",
              {
                ref: "statusReportsTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.reportData, "max-height": "500" },
                on: { "cell-click": _vm.toggleRowExpansion },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "expand" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "h5",
                                    { staticClass: "status-report-label" },
                                    [
                                      _vm._v(
                                        "\n                FW Versions:\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEmpty(scope.row.data.firmware_versions)
                                    ? _c("div", [_c("p", [_vm._v("No data")])])
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.data.firmware_versions,
                                          function (value, key) {
                                            return _c(
                                              "el-row",
                                              {
                                                key: key,
                                                attrs: { gutter: 10 },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            key
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "h5",
                                    { staticClass: "status-report-label" },
                                    [
                                      _vm._v(
                                        "\n                Settings:\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEmpty(scope.row.data.current_settings)
                                    ? _c("div", [_c("p", [_vm._v("No data")])])
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.data.current_settings,
                                          function (value, key) {
                                            return _c(
                                              "el-row",
                                              {
                                                key: key,
                                                attrs: { gutter: 10 },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            key
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "h5",
                                    { staticClass: "status-report-label" },
                                    [
                                      _vm._v(
                                        "\n                Statistics:\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEmpty(scope.row.data.statistics)
                                    ? _c("div", [_c("p", [_vm._v("No data")])])
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.data.statistics,
                                          function (value, key) {
                                            return _c(
                                              "el-row",
                                              {
                                                key: key,
                                                attrs: { gutter: 10 },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            key
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c(
                                    "h5",
                                    { staticClass: "status-report-label" },
                                    [
                                      _vm._v(
                                        "\n                Status:\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isEmpty(scope.row.data.status)
                                    ? _c("div", [_c("p", [_vm._v("No data")])])
                                    : _c(
                                        "div",
                                        _vm._l(
                                          scope.row.data.status,
                                          function (value, key) {
                                            return _c(
                                              "el-row",
                                              {
                                                key: key,
                                                attrs: { gutter: 10 },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("capitalize")(
                                                            key
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(value) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2670239196
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "Date",
                    "render-header": _vm.dateFilterHeader,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("time-zone-formatter", {
                              attrs: { "current-time": scope.row.timestamp },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1069557181
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "Context",
                    prop: "data.context",
                    filters: _vm.tagFilters,
                    "filter-method": _vm.filterTag,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.eventContextByType(
                                    scope.row.type,
                                    scope.row.data.context
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4040865209
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "Firmware Version" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          app " +
                                _vm._s(
                                  _vm.get(
                                    scope.row.data,
                                    "firmware_versions.app",
                                    "Unknown"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3636043771
                  ),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "Summary" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("SummaryReportPopover", {
                              attrs: { report: scope.row },
                            }),
                            _vm._v(" "),
                            scope.row["is_dpd"]
                              ? _c(
                                  "span",
                                  [
                                    _vm.deviceIsPlugged(scope.row)
                                      ? _c("font-awesome-icon", {
                                          attrs: { icon: "plug" },
                                        })
                                      : _c("font-awesome-icon", {
                                          attrs: {
                                            icon: "battery-three-quarters",
                                          },
                                        }),
                                  ],
                                  1
                                )
                              : _c("font-awesome-icon", {
                                  attrs: { icon: "plug" },
                                }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    218459229
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "status-reports-table__footer-pagination" },
          [
            _vm.error.value
              ? _c("el-alert", {
                  staticStyle: { "margin-bottom": "14px" },
                  attrs: {
                    title: _vm.error.message,
                    type: "info",
                    center: "",
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                small: true,
                "current-page": _vm.pagination.currentPage,
                "page-sizes": [25, 50, 100, 200],
                "page-size": _vm.pagination.limit,
                layout: "sizes, prev, pager, next",
                total: _vm.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.pagination, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.pagination, "currentPage", $event)
                },
                "size-change": _vm.onPageSizeChange,
                "current-change": _vm.onPageChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }